
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This release introduces support for Hybrid mobile app development using NativeScript. We also have a new Project Tool that allows you to quickly start new PX Blue projects.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;